import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Observable } from 'rxjs/Rx';

import { AuthService } from './auth.service';
import { CookieManagerService } from './cookie-manager.service';

import { SharedConstants } from '../shared.const';
import { MainConstants } from '../../modules/main.const';

import * as CryptoJS from 'crypto-js';

@Injectable()
export class AuthGuardService implements CanActivate {
  private preAuth: boolean = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieManagerService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!Cookie.get(SharedConstants.basicConstans.cookieToken)) {
      window.location.href = SharedConstants.basicConstans.loginUrl;
      return false;
    }
    return true;
  }

  isClient(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    let user = CryptoJS.AES.decrypt(Cookie.get(SharedConstants.basicConstans.userToken), MainConstants.basicConstans.userKey);

    return user.is_client;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts